<template lang="pug">
    ApolloQuery(:query="require('../graphql/CareerEvent.gql')",:variables="{ locale }")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.career_event)")
            .career-event(v-else)
                MetaTags(v-bind="data.career_event.meta_tags")
                LayoutBannerBreadCrumb(:locale='locale',  :cover="data.career_event.cover" :name="data.career_event.title" :prefix="locale == 'en' ? 'Staff Benefits & Training' : '員工福利及培訓'" prefix_url="/career")
                WidgetCard(v-for="(repeater, index) in data.career_event.image_with_text", :locale="locale", v-bind:key="index", v-bind="repeater")
                .grey-area.container(v-if="data.career_event.gallery_header")
                    div(v-html="data.career_event.gallery_header")
                WidgetSlider(:gallery="data.career_event.gallery", :duration="data.career_event.gallery_duration")
                WidgetHowToJoin(v-if="data.career_event.page_bottom", v-bind="data.career_event.page_bottom")
</template>

<script>
    import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
    import WidgetCard from "../components/WidgetCard.vue";
    import WidgetSlider from "../components/WidgetSlider.vue";
    import WidgetHowToJoin from "../components/WidgetHowToJoin.vue";
    import Loading from "../components/Loading";
    import PageNotFound from './PageNotFound';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "CareerPath",
        props: {
            locale: String
        },
        components: {
            MetaTags,
            PageNotFound,
            LayoutBannerBreadCrumb,
            WidgetCard,
            WidgetSlider,
            WidgetHowToJoin,
            Loading
        }
    };
</script>

<style lang="sass" scoped>
    @import "~bootstrap/scss/functions"
    @import "~bootstrap/scss/variables"
    @import "~bootstrap/scss/mixins"

    .container-careerpath
        max-width: 1140px
        margin: 0 auto

        .image
            text-align: center
    .grey-area
        div
            padding: 1rem .5rem
            background: #ececec
            text-align: center
            font-size: 1rem
        @include media-breakpoint-down(lg)
            margin-top: -1rem
</style>
